import React from "react";
import { useSelector } from "react-redux";
import DashboardSingleScanMapComponent from "./dashboardSingleScanMap.component";
import { useJsApiLoader } from "@react-google-maps/api";

const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

export default function DashboardSingleScanMapContainer({ center, detail }) {
  const locale = useSelector((state) => state.profile.language);
  const isMapDisabled = process.env.REACT_APP_DISABLE_CONSUMER_SCAN_MAP === 'true';

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: API_KEY,
    language: locale,
    skip: isMapDisabled,
  });

  return (
    <DashboardSingleScanMapComponent
      center={center}
      isLoaded={isLoaded}
      isMapDisabled={isMapDisabled}
      detail={detail}
    />
  );
}
